import React from "react"
import classNames from "classnames"
import { render } from "storyblok-rich-text-react-renderer"

import StoryblokLink from "./StoryblokLink"

import { renderHeadline } from "../contentEdit"
import DecorationComponents from "../componentKeys/decorationHeroImages"

import { HeaderType } from "../../types"

type HeroProps = {
  header: HeaderType[]
}

const Hero = ({ header }: HeroProps) => {
  const content = header ? header[0] : null
  const title = renderHeadline(content?.pageTitle, "c-hero__headline")
  const text = render(content?.introParagraph)

  const renderClasses = () =>
    classNames("c-hero", {
      "c-hero--imageVertical": content?.imageSize === "663x990",
      "c-hero--imageVerticalBig": content?.imageSize === "805x994",
      "c-hero--imageHorizontalCommon": content?.imageSize === "944x620",
      "c-hero--imageHorizontalStudy": content?.imageSize === "944x620CaseStudy",
      "c-hero--imageHorizontalSmall": content?.imageSize === "802x620",
      "c-hero--imageHorizontalMedium": content?.imageSize === "941x705",
      "c-hero--imageHorizontalLarge": content?.imageSize === "1083x620",
    })

  const renderColumnClasses = () =>
    classNames("col-md-10 col-lg-8 col-xl-6", {
      "col-xxl-5": content?.imageSize !== "802x620",
    })

  const decorationImage = content?.imageSize
    ? React.createElement(DecorationComponents(content?.imageSize), {
        key: content?.imageSize,
        image: content.image.filename,
      })
    : null

  return (
    <section className={renderClasses()}>
      <div className="container">
        <div className="row">
          <div className={renderColumnClasses()}>
            <div className="c-hero__content">
              {title}
              <div className="c-hero__text">{text}</div>
              {content?.ctaLink && content?.ctaButton && (
                <StoryblokLink
                  to={content?.ctaLink}
                  isInternalAnchor={
                    content?.ctaLink.cached_url.charAt(0) === "#"
                  }
                  className="d-inline-block mt-5"
                >
                  <span className="btn-secondary">{content?.ctaButton}</span>
                </StoryblokLink>
              )}
            </div>
          </div>
        </div>
      </div>

      {decorationImage}
    </section>
  )
}

export default Hero
